import { Donvi } from './donvi';
import { Dmlinhvucgopy } from './dmlinhvucgopy';

export class Hoidap {
  id: number;
  hoten: string;
  diachi: string;
  thudientu: string;
  dienthoai: string;
  tieude: string;
  noidung: string;
  taptin: string;
  duyet: number;
  showanswer: boolean = false;
  noidungtraloi: string;
  taptintl: string;  
  dmdonvi: Donvi;
  dmdonviid: number;
  isactive: number;
  createddate: Date;
  createdbyuserid: number;
  modifieddate: Date;
  modifiedbyuserid: number;  
  linhvucid: number;
  gioitinh: number;
  ngaytraloi: Date;
  tenclass: string;
  markread: number;
  noidungrutgon: string;
}